import bg from '../assets/bg.png';
import founder from '../assets/founder.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import bracelet from '../assets/bracelet.png';
import logo from '../assets/logo.png';
import product01 from '../assets/product01.png';
import product02 from '../assets/product02.png';
import product03 from '../assets/product03.png';
import overlaybg from '../assets/overlaybg.png';
import leaf from '../assets/leaf.png';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import laurels from '../assets/laurels.png';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import elpis from '../assets/elpis.png';
import arrowLeft from '../assets/left-arrow.png';
import arrowRight from '../assets/right-arrow.png';

export default {
  bg,
  founder,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  bracelet,
  logo,
  product01,
  product02,
  product03,
  overlaybg,
  leaf,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  elpis,
  arrowLeft,
  arrowRight,
};
